// extracted by mini-css-extract-plugin
module.exports = {"infoMsg":"FreeWrite_infoMsg__fpoZh"};